"use client";
import clsx from "clsx";
import Image from "next/image";
import { Suspense, useEffect, useRef } from "react";
import type { SwiperOptions } from "swiper/types";

import Skeleton from "@/components/atoms/Skeleton";
import Video from "@/components/atoms/Video";

import styles from "./media-gallery.module.css";
const SwiperGallery = ({
  media,
  activeIndex,
  inModal = false,
  className,
}: {
  media:
    | {
        href: string;
        alt: string;
        type: string;
      }[]
    | undefined;
  activeIndex: number | null;
  inModal?: boolean;
  className?: string;
}) => {
  const swiperRef = useRef<HTMLElement | null>(null);

  useEffect(() => {
    const swiperContainer = swiperRef.current;
    if (!swiperContainer) return;
    const mobileParams: SwiperOptions = {
      loop: true,
      slidesPerGroup: 1,
      slidesPerView: "auto",
      spaceBetween: 5,
    };
    const params: SwiperOptions = {
      navigation: true,
      loop: true,
      initialSlide: activeIndex || 0,

      keyboard: true,
      pagination: {
        el: ".swiper-pagination",
        type: "fraction",
      },
      injectStyles: [
        `
      .swiper-button-next,
      .swiper-button-prev {
        color: black;

      }
      .swiper-button-next:hover, .swiper-button-prev:hover{
        color: var(--color-hover);
      }
      // .swiper-button-next, .swiper-button-prev {
      //   width: max(2rem, 2.5vw);
      //   height: max(2rem, 2.5vw);
      //   background-color: white;
      //   border-radius: 100%;
      // }
      .swiper-button-next:after{
        content: '>';
        font-size: max(1rem, 1.25vw);
        padding-bottom: 0.25rem;
      }
      .swiper-button-prev:after{
        content: '<';
        font-size: max(1rem, 1.25vw);
        padding-bottom: 0.25rem;
      }
      .swiper-pagination {
        top: 10px;
        bottom: auto;
      }
      `,
      ],
    };
    Object.assign(swiperContainer, inModal ? params : mobileParams);
    (swiperContainer as any).initialize();
  }, [activeIndex, inModal]);
  return (
    <swiper-container
      ref={swiperRef}
      init="false"
      style={{height:"100%", width:"100%"}}
      className={clsx(
        styles.swiper,
        className,
        inModal && styles["in-modal"],
        "swiper-wrapper"
      )}
    >
      {media?.map((image, i) => (
        <swiper-slide key={`${image.href}-${i}`} className="swiper-slide">
          <div
            className={clsx(
              "swiper-zoom-container",
              styles.swiper__zoom__container
            )}
          >
            {image.type === "image" ? (
              <>
                <Image
                  src={image?.href}
                  alt=""
                  fill
                  quality={80}
                  className={styles["image-swiper"]}
                  sizes={`(max-width: 1024px) 100vw, (max-width: 2560px) 60vw`}
                  priority={i === 0}
                />
                <Skeleton height="100%" />
              </>
            ) : (
              <div className={styles.video}>
                <Suspense fallback={<Skeleton height="100%" />}>
                  <Video
                    url={image?.href}
                    playing
                    loop
                    muted
                    width="100%"
                    height="100%"
                  />
                </Suspense>
              </div>
            )}
          </div>
        </swiper-slide>
      ))}
    </swiper-container>
  );
};

export default SwiperGallery;
